import { IAppStorage } from "./IAppStorage";
import OLMap from 'ol/Map';
import MapEvent from "ol/MapEvent";
import { MapViewSettings } from "./MapViewSettings";
import { AppStorage } from "./AppStorage";

//stores JSON serialised MapInfo object, used to maintain map state across sessions
export class MapViewStore {

    private initialised: boolean = false;
    private storage: IAppStorage;

    constructor(
        private storeKey: string
    ) {
        this.storage = new AppStorage();        
    }

    public initMap = (map: OLMap, enableBoundsTracking: boolean): void => {
        if (!this.initialised) {
            if (enableBoundsTracking) {

                let onMapMoveEnd = (e: MapEvent): void => {
                    let map: OLMap = e.map;
                    let contreCoord = map.getView().getCenter();
                    let m: MapViewSettings = this.getMapInfo();
                    m.centre = [contreCoord[0], contreCoord[1]];
                    m.zoom = map.getView().getZoom();
                    this.saveMapStorage(m);
                }

                //remember map extent           
                map.on('moveend', function (e: MapEvent) {
                    onMapMoveEnd(e);
                });
            }
            this.initialised = true;
        }
    }

    public getMapInfo(): MapViewSettings {
        let m: MapViewSettings = (this.storage.getValueFromJson(this.storeKey, this.reviver) as MapViewSettings) || new MapViewSettings();
        if (!m.baselayer) {
            m.baselayer = "Contoured";
        }
        return m;
    }

    public isLayerVisible = (name: string, defaultValue: boolean): boolean => {
        let m: MapViewSettings = this.getMapInfo();
        if (!m.overlays.has(name)) {
            m.overlays.set(name, defaultValue);
            this.saveMapStorage(m);
        }
        return m.overlays.get(name);
    }

    public onLayerVisibiltyChanged = (name: string, visible: boolean): void => {
        let m: MapViewSettings = this.getMapInfo();
        m.overlays.set(name, visible);
        this.saveMapStorage(m);
    }

    public onBaseLayerChanged = (name: string, visible: boolean): void => {
        let m: MapViewSettings = this.getMapInfo();
        m.baselayer = name;
        this.saveMapStorage(m);
    }

    public onAutoCloseBaseLayerChanged = (autoclose: boolean): void => {
        let m: MapViewSettings = this.getMapInfo();
        m.closePanelOnBaseLayerChange = autoclose;
        this.saveMapStorage(m);
    }

    private saveMapStorage = (mapInfo: MapViewSettings): void => {
        this.storage.setValue(this.storeKey, JSON.stringify(mapInfo, this.replacer));
    }

    public onOpacityChanged = (opacity: number): void => {
        let m: MapViewSettings = this.getMapInfo();
        m.opacity = opacity;
        this.saveMapStorage(m);
    }

    public onActivePanelChanged = (name: string): void => {
        let m: MapViewSettings = this.getMapInfo();
        m.activePanel = name;
        this.saveMapStorage(m);
    }

    public onCurrentToolChanged = (name: string): void => {
        let m: MapViewSettings = this.getMapInfo();
        m.currentTool = name;
        this.saveMapStorage(m);
    }

    private replacer(key, value): object {
        if (value instanceof Map) {
            return {
                dataType: 'Map',
                value: Array.from(value.entries()), // or with spread: value: [...value]
            };
        } else {
            return value;
        }
    }

    private reviver(key, value): object {
        if (typeof value === 'object' && value !== null) {
            //if (value.dataType === 'Map') {
            if (key === 'baselayers' || key === 'overlays') {
                return new Map(value.value);
            }
        }
        return value;
    }

}